module.exports = __webpack_public_path__ + "img/about2.572f998c.jpg";